import React, { useEffect, useState } from 'react'
import Select from 'react-select';
import AppBreadCrumb from '../../common/AppBreadCrumb'


import { createRole, fetchRole, UpdateRole } from '../../../api/milma_admin/RolesAPI';

import { handleApiError } from '../../../api/risapi';
import AppToaster from '../../AppToaster';
import { useNavigate } from 'react-router-dom';
import { capitalizeFirstLetter, replaceHyphenwithSpace } from '../../../commonfunctions';
import { getPermissionGroups } from '../../../api/milma_admin/PermissionsAPI';

const RolesForm = (props) => {

  const { formType, currentRoleId } = props;
  const navigate = useNavigate();

  const [currentRole, setCurrentRole] = useState(null);
  const [currentRoleError, setCurrentRoleError] = useState(null);
  const [permissionGroups, setPermissionGroups] = useState([]);

  const [showToaster, setShowToaster] = useState(false);
  const [toaster, setToaster] = useState({});
  const [selectedPermissions, setSelectedPermissions] = useState(new Set());



  useEffect(() => {

    getPermissionGroups({ paginate: false }, function (response) {
      console.log("hello", response['permission-groups']);

      setPermissionGroups(response['permission-groups']);
      ;

    });



  }, []);




  const customStyles = {
    option: (provided, role) => ({
      ...provided,
      color: 'black', // Set label color to black
      backgroundColor: role.isFocused ? '#11a1fd' : 'white', // Blue on hover, white otherwise
      color: role.isFocused ? 'white' : 'black', //White text on blue, black otherwise
      padding: '15',
    }),
    control: (provided) => ({
      ...provided,
      borderColor: 'rgba(98,98,98, 0.4)', // Optional: customize the border
    }),
    singleValue: (provided, Role) => ({
      ...provided,
      textAlign: 'left', // Align the selected value text to the left
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: '0.5rem 0.5rem',
    }),

  };


  const saveAddRoleForm = (exitForm) => {

    console.log("new Role is", currentRole);

    setCurrentRoleError({});
     const permissionsArray = [...selectedPermissions];
    const saveRole = { ...currentRole, permission_ids: permissionsArray };

    createRole(saveRole, function (response) {
      console.log("in createRole", response);

      if ("role" in response) {


        // setSaveCompleted(prevRole => !prevRole); // Toggle the Role
        if (exitForm) {

          navigate('/general/roles', {
            state: { message: 'Role saved successfully!' }
          });
        }
        else {
          setShowToaster(true);
          setToaster({ type: 'success', heading: 'Success', message: 'Role Added Successfully' });
          setCurrentRole(null);
          setSelectedPermissions(new Set());
        }
      }
      else {
        // Use the generic error handling function
        console.log("error Response", response);

        handleApiError(response, setCurrentRoleError);
      }


    });

  }

  const handleResetRoleForm = () => {

    setCurrentRole(null);
    setCurrentRoleError(null);
  }

  const getTitle = () => {

    console.log("formType", formType);

    if (formType == 'create') {
      return 'Create New Role Wizard'
    }
    else {
      return 'Edit Role Wizard'
    }
  }

  useEffect(() => {
    setCurrentRole(null);

    if (formType != null && formType != 'create' && currentRoleId) {

      fetchRole(currentRoleId, function (response) {
        console.log("in fetchRole", response);

        if ("role" in response) {
          // response.role.state.selectedoption = { label: response.role.state.name, value: response.role.state.id };
          // if(response.role.role)
          // {
          //   response.role.role.selectedoption = {label: response.role.role.name, value: response.role.role.id };

          // }
          // else
          // {
          //   //  response.role.role = null;
          // }
          setCurrentRole(response.role);
          setSelectedPermissions(new Set(response.role?.permission_ids));



        }



      });
    }

  }, [formType, currentRoleId]);


  const saveEditRoleForm = (exitForm) => {


    setCurrentRoleError(null);
    const permissionsArray = [...selectedPermissions];
    const saveRole = { ...currentRole, permission_ids: permissionsArray };
    UpdateRole(saveRole, function (response) {
      console.log("in updateRole", response);

      if ("role" in response) {

        // setToaster({ type: 'success', heading: 'Success', message: 'Role Updated Successfully' });
        // setShowToaster(true);
        navigate('/general/roles', {
          state: { message: 'Role Updated successfully!' }
        });

      }
      else {
        // Use the generic error handling function
        handleApiError(response, setCurrentRoleError);
      }


    });
  }

  // Function to handle individual permission checkbox changes
  const handlePermissionChange = (permissionId, isChecked) => {
    setSelectedPermissions(prevSelected => {
      const newSelected = new Set(prevSelected);
      if (isChecked) {
        newSelected.add(permissionId);
      } else {
        newSelected.delete(permissionId);
      }
      console.log("newselected",newSelected);
      return newSelected;
    });
    console.log("selectedPermissions",selectedPermissions);
    
   
  };

  // Function to handle the "Select All" checkbox for a group
  const handleSelectAllGroup = (permissionsInGroup, isChecked) => {
    setSelectedPermissions(prevSelected => {
      const newSelected = new Set(prevSelected);
      if (isChecked) {
        permissionsInGroup.forEach(permission => newSelected.add(permission.id));
      } else {
        permissionsInGroup.forEach(permission => newSelected.delete(permission.id));
      }
      console.log("newselected",newSelected);
      
      return newSelected;
    });

   
  };

  // Function to check if all permissions in a group are selected
  const isGroupFullySelected = (permissionsInGroup) => {
    return permissionsInGroup.every(permission => selectedPermissions.has(permission.id));
  };

  // Helper function to check if a permission is selected
  const isPermissionSelected = (permissionId) => selectedPermissions.has(permissionId);


    // Handle "Select All" for a group
  const handleSelectAllChange = (groupPermissions, isChecked) => {
    setSelectedPermissions(prevSelected => {
      const newSelected = new Set(prevSelected);
      if (isChecked) {
        groupPermissions.forEach(permission => newSelected.add(permission.id));
      } else {
        groupPermissions.forEach(permission => newSelected.delete(permission.id));
      }
         console.log("newselected",newSelected);
      return newSelected;
    });
   
  };

  return (
    <>
      <AppToaster showToaster={showToaster} setShowToaster={setShowToaster} toaster={toaster}></AppToaster>
      <main>
        <div className="container-fluid">
          {/* Breadcrumb start */}
          <AppBreadCrumb title={getTitle()}>
          <li><a className="f-s-14 f-w-500" href="#">Admin</a></li>
          
            <li >
              <a className="f-s-14 f-w-500" href="#">Roles</a>
            </li>
            <li className="active">
              <a className="f-s-14 f-w-500" href="#">{capitalizeFirstLetter(formType)}</a>
            </li>
          </AppBreadCrumb>


          {/* Breadcrumb end */}
          {/* ready to use form start */}
          <div className="row">
            {/* Book Appointment Form start */}
            <div className="col-12">
              <div className="card">
                <div className="card-header">
                  <h5>{formType == 'create' ? 'Add New' : 'Edit'} Role  {formType == 'edit' ? (':' + currentRole?.name) : ''}</h5>
                </div>
                <div className="card-body">
                  <form className="app-form">
                    <div className="row">
                    
                      <div className="col-md-12">
                        <div >
                          <label className="form-label">Role Name *</label>
                          <input className="form-control" placeholder="Enter Role Name" value={currentRole ? currentRole.name : ''} onChange={(e) => setCurrentRole({ ...currentRole, name: e.target.value })} required type="text" />
                        </div>
                        <div className="mb-3">
                          <span className="text-danger" >{currentRoleError?.name}</span>
                        </div>
                      </div>


                      <div className="col-12 floating-select">
                        <div >
                          <label className="form-label">Permissions *</label>

                        </div>

                        <div style={{
                          display: 'grid',
                          gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
                          gap: '20px'
                        }}>
                          {permissionGroups.map(group => (
                            <div
                              key={group.id}
                              style={{
                                border: '1px solid #e0e0e0',
                                padding: '16px',
                                borderRadius: '8px',
                                backgroundColor: '#f9f9f9'
                              }}
                            >
                              {/* Group header with Select All checkbox */}
                              <div style={{ display: 'flex', marginBottom: '12px' }}>
                                 <input
                                    type="checkbox"
                                    onChange={(e) => handleSelectAllChange(group.permissions, e.target.checked)}
                                    checked={isGroupFullySelected(group.permissions)}
                                    style={{ marginRight: '8px' }}
                                  />
                                <h6 className='text-start' style={{ margin: 0, textTransform: 'capitalize' }}>{replaceHyphenwithSpace(group.name)}</h6>
                                <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                                 
                                  
                                </label>
                              </div>
                              <hr style={{ margin: '0 0 12px 0', border: 'none', borderTop: '1px solid #e0e0e0' }} />

                              {/* List of permissions for the group */}
                              <div>
                                {group.permissions.map(permission => (
                                  <div key={permission.id} style={{ marginBottom: '8px' }}>
                                    <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                                      <input
                                        type="checkbox"
                                        value={permission.id}
                                        checked={isPermissionSelected(permission.id)}
                                        onChange={(e) => handlePermissionChange(permission.id, e.target.checked)}
                                        style={{ marginRight: '8px' }}
                                      />
                                      {replaceHyphenwithSpace(permission.name).split(' ')[0]}
                                    </label>
                                  </div>
                                ))}
                              </div>
                            </div>
                          ))}
                        </div>

                      </div>



                      <div className="col-12">
                        <div className="text-end">
                          {formType == 'create' ? (
                            <>
                              <button className="btn btn-outline-primary me-2 btn-sm btn-md  " type="button" onClick={() => saveAddRoleForm(0)}>Save + Next
                                <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M4 12L9 17L20 6" stroke="currentColor" strokewidth={2} strokelinecap="round" strokelinejoin="round" />
                                  <path d="M20 17C20 18.6569 18.6569 20 17 20C15.3431 20 14 18.6569 14 17C14 15.3431 15.3431 14 17 14V17H22" stroke="currentColor" strokewidth={2} strokelinecap="round" strokelinejoin="round" />
                                </svg>


                              </button>
                              <button className="btn btn-primary me-2 btn-sm btn-md " type="button" onClick={() => saveAddRoleForm(1)}>Save + Exit
                                <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M4 12L9 17L20 6" stroke="currentColor" strokewidth={2} strokelinecap="round" strokelinejoin="round" />
                                  <path d="M11 12H22M11 12L15 8M11 12L15 16" stroke="currentColor" strokewidth={2} strokelinecap="round" strokelinejoin="round" />
                                </svg>


                              </button>
                              <button className="d-none d-md-inline-block btn btn-danger btn-sm btn-md btn-mobile-padding" onClick={handleResetRoleForm} type="reset">Reset</button>
                            </>
                          ) : (
                            <>
                              <button className="btn btn-primary me-2 btn-sm btn-md  " type="button" onClick={() => saveEditRoleForm(1)}> Update
                                <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M4 12L9 17L20 6" stroke="currentColor" strokewidth={2} strokelinecap="round" strokelinejoin="round" />
                                  <path d="M20 17C20 18.6569 18.6569 20 17 20C15.3431 20 14 18.6569 14 17C14 15.3431 15.3431 14 17 14V17H22" stroke="currentColor" strokewidth={2} strokelinecap="round" strokelinejoin="round" />
                                </svg>


                              </button>
                              <button className="btn btn-danger me-2 btn-sm btn-md  " type="button" onClick={() => navigate('/general/roles')}> Cancel
                                <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M4 12L9 17L20 6" stroke="currentColor" strokewidth={2} strokelinecap="round" strokelinejoin="round" />
                                  <path d="M20 17C20 18.6569 18.6569 20 17 20C15.3431 20 14 18.6569 14 17C14 15.3431 15.3431 14 17 14V17H22" stroke="currentColor" strokewidth={2} strokelinecap="round" strokelinejoin="round" />
                                </svg>


                              </button>
                            </>
                          )}

                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            {/* Book Appointment Form end */}




          </div>
          {/* ready to use form and */}
        </div>
      </main>

    </>
  )
}

export default RolesForm
